import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challenge() {
  return (
    <section className="challenge_save p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <h2>
              Challenges & <span style={{ color: "#198463" }}>Solutions</span>
            </h2>
            <p>
              One of the obstacles we encountered during the development of this
              project was that the Application Programming Interfaces (APIs) of
              the product stores to extract data were not accessible.
            </p>
            <p>
              To overcome this issue, we developed an efficient web scraper that
              can easily extract data from the stores directly. Additionally, we
              have incorporated a monitor that provides us with an alert if
              anything changes in the stores in terms of data, so that we can
              modify it accordingly.
            </p>
            <p>
              Moreover, we employ automated scraping tools to acquire different
              products' data and prices from different stores.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/save-win/tek_img_02.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={571}
                height={540}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challenge;
